import { CommonModule } from "@angular/common";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { Environment, APP_ORIGIN_NAME_TOKEN, NON_PHI_FAX_ORIGIN_TOKEN } from "@kno2/core/configuration";
import { SharedThemeModule } from "@kno2/layout";
import { InputMaskModule } from "@ngneat/input-mask";
import { environment } from "../environments/environment";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { CoreModule } from "./core/core.module";

@NgModule({
    declarations: [AppComponent],
    bootstrap: [AppComponent],
    imports: [CoreModule, BrowserModule, BrowserAnimationsModule, CommonModule, InputMaskModule, AppRoutingModule, SharedThemeModule.forRoot()],
    providers: [
        {
            provide: Environment,
            useValue: new Environment(environment)
        },
        {
            provide: APP_ORIGIN_NAME_TOKEN,
            useValue: `${environment.brand.displayName}-Desktop`.replace(" ", "-")
        },
        {
            provide: NON_PHI_FAX_ORIGIN_TOKEN,
            useValue: `Desktop-${environment.brand.displayName}-Non-Patient`.replace(" ", "-")
        },
        provideHttpClient(withInterceptorsFromDi())
    ]
})
export class AppModule {}
